import {Tracking} from "../../tracking/tracking";
import {slideChangeTracker} from "./productSwiper";
import {SwiperElementType, SwiperType} from "../molecules/SwiperTypes";
import PinitComponent from "../pinitComponent";

class BlogImageSwiper {
  public static run(params: {
    swiperDiv: HTMLDivElement;
    swipedTracking?: string;
    clickedTracking?: string;
    looped?: boolean;
  }) {
    const swiperContainer = params.swiperDiv.querySelector<SwiperElementType>("swiper-container");
    if (!swiperContainer) return;
    const slides = swiperContainer.querySelectorAll("swiper-slide");
    if (!slides.length) {
      params.swiperDiv.parentElement?.removeChild(params.swiperDiv);

      return;
    }

    if (params.looped !== false) swiperContainer.setAttribute("loop", "true");
    PinitComponent.pinit(swiperContainer);

    const {clickedTracking, swipedTracking} = params;

    if (clickedTracking) {
      swiperContainer.swiper.slides.forEach((slide) => {
        const anchor = slide.querySelector("a:not(.pin-it)");
        if (anchor !== null) {
          anchor.addEventListener("click", () => {
            Tracking.sendEvent(clickedTracking);
          });
        }
      });
    }

    if (swipedTracking) {
      const slideChange = slideChangeTracker(swipedTracking);
      swiperContainer.addEventListener("swiperslidechange", (event: CustomEvent<SwiperType[]>) =>
        slideChange(event.detail[0]),
      );
    }
  }
}

export default BlogImageSwiper;
